import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import IconRowWithArrow from "../../../components/shared/IconRowWithArrow";
import { ReactComponent as FileUserIcon } from "../../../assets/icons/file-user.svg";
import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

function ProfileSettingPage() {
  const navigate = useNavigate();

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            تنظیمات
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto", display: "block" }}>
        <Box
          sx={{
            mb: 2,
            bgcolor: "grey.7",
            borderRadius: "4px",
            p: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <FileUserIcon width={16} height={20} />
          <Typography ml={1} variant="h5" color={"grey.3"}>
            حساب
          </Typography>
        </Box>
        {[
          {
            title: "اطلاعات کاربری",
            action: () => {
              navigate("/app/profile/setting/personal");
            },
          },
          {
            title: "سجام",
            action: () => {
              navigate("/app/profile/setting/sejam/status");
            },
          },
          {
            title: "حساب متصل",
            action: () => {
              navigate("/app/profile/setting/contract");
            },
          },
        ].map((item) => {
          return (
            <IconRowWithArrow
              sx={{ mb: "24px" }}
              key={item.title}
              title={item.title}
              onClick={item.action}
            />
          );
        })}
        <Box
          sx={{
            my: 2,
            bgcolor: "grey.7",
            borderRadius: "4px",
            p: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <LockIcon width={16} height={20} />
          <Typography ml={1} variant="h5" color={"grey.3"}>
            امنیتی
          </Typography>
        </Box>
        {[
          {
            title: "تغییر کلمه عبور",
            action: () => {
              navigate("/app/profile/setting/change-password");
            },
          },
        ].map((item) => {
          return (
            <IconRowWithArrow
              sx={{ mb: "24px" }}
              key={item.title}
              title={item.title}
              onClick={item.action}
            />
          );
        })}
      </PageContentContainer>
    </>
  );
}

export default ProfileSettingPage;
